module.exports = __webpack_public_path__ + "66aa5abf9697a7618de9be8aa50e3bf9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/bat.png
// module id = 2366
// module chunks = 0